import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import type { MonthlyUnPaidArrival } from '../domains/entities/MonthlyData';
import { ArrivalStatus } from '@/coreDomainsModule/entities/arrival';
import { i18n } from '@/i18n';

/**
 * propsの定義
 * @param arrivalStatus - 注文ステータス
 * @param unit - 単位
 * @param unPaidArrivals - 未払いの注文
 */
type Props = {
  arrivalStatus: ArrivalStatus;
  unit?: string;
  unPaidArrivals?: MonthlyUnPaidArrival[];
  approvalRequestedArrival?: MonthlyUnPaidArrival[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationBadge',
  props: {
    arrivalStatus: {},
    unit: { default: '' },
    unPaidArrivals: { default: undefined },
    approvalRequestedArrival: { default: undefined }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "8d8948ea": (tooltipHeightPixel.value)
}))

const t = i18n.t;

const props = __props;

const unit = computed(() => props.unit ?? '');

const textLines = computed(() => {
  switch (props.arrivalStatus) {
    case ArrivalStatus.Unpaid: {
      const resultStr: string[] = [];
      props.unPaidArrivals?.forEach((arrival) => {
        resultStr.push(
          t('納期情報バッヂ', {
            day: arrival.crossDate?.day,
            month: t(`${arrival.crossDate?.month}月`),
            value: `${arrival.amount.addComma()}${unit.value}`,
          })
        );
      });
      return resultStr;
    }
    case ArrivalStatus.ApprovalRequested: {
      const resultStr: string[] = [];
      props.approvalRequestedArrival?.forEach((arrival) => {
        resultStr.push(
          t('納期情報バッヂ', {
            day: arrival.crossDate?.day,
            month: t(`${arrival.crossDate?.month}月`),
            value: `${arrival.amount.addComma()}${unit.value}`,
          })
        );
      });
      return resultStr;
    }
    default:
      return [];
  }
});

const tooltipVisible = ref(false);
const tooltipPosition = ref({ top: 0, left: 0 });
let targetElement: HTMLElement | null = null;

/**
 * ツールチップの表示を切り替える
 * @param event - マウスイベント
 */
const showTooltip = (event: MouseEvent) => {
  tooltipVisible.value = true;

  // 親要素の位置を取得してツールチップの位置を計算
  targetElement = event.currentTarget as HTMLElement;
  const rect = targetElement.getBoundingClientRect();

  tooltipPosition.value = {
    top: rect.top + window.scrollY - tooltipHeight.value - 2.5, // 親要素の上に表示
    left: rect.left + window.scrollX + rect.width / 2, // 親要素の中央に配置
  };
};

const tooltipHeight = computed(() => {
  return 10 + 20 * textLines.value.length;
});

const tooltipHeightPixel = computed(() => {
  return `${tooltipHeight.value}px`;
});

/**
 * ツールチップを非表示にする
 */
const hideTooltip = () => {
  tooltipVisible.value = false;
  targetElement = null;
};

/**
 * スクロール時の非表示処理
 */
let scrollTimeout: number | null = null;

/**
 * スクロール時の非表示処理（50ms後に実行）
 */
const handleScroll = () => {
  if (scrollTimeout !== null) {
    clearTimeout(scrollTimeout);
  }

  scrollTimeout = window.setTimeout(() => {
    hideTooltip();
  }, 50); // スクロール終了後に非表示にするため50ms待機
};

onMounted(() => {
  // スクロールが発生したらツールチップを非表示にする
  window.addEventListener('scroll', handleScroll, true); // true を指定してキャプチャフェーズでイベントをキャッチ
  document.addEventListener('scroll', handleScroll, true); // ドキュメント全体も監視
});

onBeforeUnmount(() => {
  // コンポーネントが破棄される前にイベントリスナーを削除
  window.removeEventListener('scroll', handleScroll, true);
  document.removeEventListener('scroll', handleScroll, true);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "notification-badge__container",
    onMouseenter: showTooltip
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`notification-badge__circle notification-badge__circle--${_ctx.arrivalStatus.toLowerCase()}`)
    }, null, 2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ([_unref(ArrivalStatus).Unpaid, _unref(ArrivalStatus).ApprovalRequested].includes(_ctx.arrivalStatus) && tooltipVisible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "notification-badge__tooltip",
            style: _normalizeStyle({ top: tooltipPosition.value.top + 'px', left: tooltipPosition.value.left + 'px', transform: 'translateX(-50%)' }),
            onMouseleave: hideTooltip
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(textLines.value, (line, index) => {
              return (_openBlock(), _createElementBlock("span", { key: index }, [
                _createTextVNode(_toDisplayString(line), 1),
                _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1))
              ]))
            }), 128))
          ], 36))
        : _createCommentVNode("", true)
    ]))
  ], 32))
}
}

})